import cn from 'classnames';
import { PartialOptions } from 'overlayscrollbars';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import 'overlayscrollbars/overlayscrollbars.css';

const OverlayScrollbarsWithChildren =
  OverlayScrollbarsComponent as React.ComponentType<
    React.PropsWithChildren<
      React.ComponentProps<typeof OverlayScrollbarsComponent>
    >
  >;

type OverlayProps =
  React.ComponentProps<typeof OverlayScrollbarsComponent>;

type ScrollbarProps = React.PropsWithChildren<{
  options?: PartialOptions;
  style?: React.CSSProperties;
  className?: string;
}> &
  Omit<OverlayProps, 'options' | 'children'>;

const Scrollbar: React.FC<ScrollbarProps> = ({ options, className, style, children, ...props }) => {
  return (
    <OverlayScrollbarsWithChildren
      options={{
        scrollbars: { autoHide: 'scroll' },
        ...(options ?? {}),
      }}
      defer
      {...props}>
      <div style={style} className={cn('os-theme-thin-dark', className)}>
        {children}
      </div>
    </OverlayScrollbarsWithChildren>
  );
};

export default Scrollbar;
